import React from 'react';
import TrendingImage1 from "../../assets/images/trending1.jpg"
import TrendingImage2 from "../../assets/images/trending2.jpg"

const trendingProducts = [
  {
    id: 1,
    title: "Lorem Ipsum",
    description: "Pellentesque vitae fermentum nibh. Mauris mattis vel augue sed.",
    image: TrendingImage1,
    category: "JACKET"
  },
  {
    id: 2,
    title: "Lorem Ipsum",
    description: "Pellentesque vitae fermentum nibh. Mauris mattis vel augue sed.",
    image:TrendingImage2,
    category: "PROTECTION"
  }
];

const TrendingSection = () => {
  return (
    <div className="w-full py-16 px-4 lg:px-0 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-12">Trendet tani</h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {trendingProducts.map((product) => (
            <div key={product.id} className="relative overflow-hidden group">
              <div className="h-96 overflow-hidden">
                <img 
                  src={product.image} 
                  alt={product.title} 
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute bottom-0 left-0 p-6 bg-gradient-to-t from-black/70 to-transparent w-full">
                <span className="bg-white text-xs px-2 py-1 uppercase">{product.category}</span>
                <h3 className="text-white text-xl font-semibold mt-2">{product.title}</h3>
                <p className="text-gray-200 mt-1 text-sm">{product.description}</p>
                <button className="mt-4 bg-white hover:bg-gray-200 transition-colors text-black px-5 py-2 text-sm">
                  Zbulo tani
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TrendingSection;